import { Box, Tab, TabList, Tabs, Tooltip, tabClasses } from "@mui/joy";
import { Settings, Package } from "lucide-react";

interface VerticalTabsProps {
    value: string;
    onChange: (value: string) => void;
}

export function VerticalTabs({ value, onChange }: VerticalTabsProps) {
    return (
        <Box
            sx={{
                height: "100%",
                width: 70, // Fixed width for the sidebar
                borderRight: "1px solid",
                borderColor: "divider",
                bgcolor: "background.surface",
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center tabs horizontally
                pt: 2,
            }}
        >
            <Tabs
                orientation="vertical"
                value={value}
                onChange={(_, val) => typeof val === "string" && onChange(val)}
                sx={{
                    bgcolor: "transparent",
                    [`& .${tabClasses.root}`]: {
                        minHeight: 48,
                        width: 48, // Square aspect ratio
                        borderRadius: "4px",
                        justifyContent: "center",
                        mb: 1, // Spacing between tabs
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

                        // Hover State
                        "&:hover": {
                            bgcolor: "background.level1",
                        },

                        // Active State (Soft Background)
                        [`&[aria-selected="true"]`]: {
                            bgcolor: "primary.softBg",
                            color: "primary.plainColor",
                        },
                    },
                }}
            >
                <TabList
                    disableUnderline
                    sx={{
                        flexDirection: "column",
                        gap: 0,
                        p: 0,
                        alignItems: "center",
                    }}
                >
                    <Tooltip title="Details" placement="right" arrow variant="soft" size="md">
                        <Tab value="details" disableIndicator sx={{ p: 1 }}>
                            <Settings size={18} />
                        </Tab>
                    </Tooltip>

                    <Tooltip title="Products" placement="right" arrow variant="soft" size="md">
                        <Tab value="products" disableIndicator sx={{ p: 1 }}>
                            <Package size={18} />
                        </Tab>
                    </Tooltip>
                </TabList>
            </Tabs>
        </Box>
    );
}
